import { render } from "./MyShipPriceUpdate.vue?vue&type=template&id=0e61a774&scoped=true"
import script from "./MyShipPriceUpdate.vue?vue&type=script&lang=js"
export * from "./MyShipPriceUpdate.vue?vue&type=script&lang=js"

import "./MyShipPriceUpdate.vue?vue&type=style&index=0&id=0e61a774&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e61a774"]])

export default __exports__